import * as React from "react";
import { FacebookShareButton, TwitterShareButton } from "react-share";

const buttonStyle: React.CSSProperties = { padding: "10px", color: "white", borderRadius: 8, fontWeight: "bold" };

export default (props: { onClose: () => void, style?: React.CSSProperties }) => {
    return (<div className="CMS_element" style={props.style}>
        <div className="CMS_title CMS_T4"><em className="fa fa-share-alt" aria-hidden="true"></em> Publish to social media</div>
        <div className="CMS_e_row">
            Click the buttons below to post to your social media. These will appear instantly.
        </div>
        <div className="CMS_e_row" style={{ display: "flex", justifyContent: "center" }}>
            <TwitterShareButton url={window.location.href} style={{ backgroundColor: "#00aced", ...buttonStyle }}>
                <em className="fa fa-twitter" aria-hidden="true"></em> Twitter
            </TwitterShareButton>&nbsp;
            <FacebookShareButton url={window.location.href} style={{ backgroundColor: "#3b5998", ...buttonStyle }}>
                <em className="fa fa-facebook-f" aria-hidden="true"></em> Facebook
            </FacebookShareButton>
        </div>
        <div className="CMS_buttonGroup CMS_bg-R">
            <a
                className="CMS_button CMS_bCancel"
                href="#"
                onClick={(e) => {
                    e.preventDefault();
                    props.onClose();
                }}
            >
                Close
            </a>
        </div>
    </div>);
};
